import { Fragment, useEffect, useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { Falcon } from 'modules/macro';
import { Box, Typography } from 'modules/v2';
import { LoadingBars } from './LoadingBars';
import { LoadingText } from './LoadingText';
import { Container, Divider, FalconWrapper, IconContainer } from './styled';
export function AgenticLoader(props) {
    const { children, loading, error, errorLabel, loadingLabels, size = 'md' } = props;
    const [showContainer, setShowContainer] = useState(true);
    const [showChildren, setShowChildren] = useState(false);
    const [childrenFadedIn, setChildrenFadedIn] = useState(false);
    const state = useMemo(() => {
        if (loading) {
            return 'loading';
        }
        if (error) {
            return 'error';
        }
        return 'completed';
    }, [loading, error]);
    useEffect(() => {
        if (state === 'completed') {
            setShowContainer(false);
            setShowChildren(true);
        }
        else {
            setShowContainer(true);
            setShowChildren(false);
            setChildrenFadedIn(false);
        }
    }, [state]);
    const fontSizeMap = {
        sm: 'tiny',
        md: 'small',
        lg: 'medium',
    };
    const loadingContent = (<Fragment>
      <IconContainer>
        <LoadingBars size={size}/>
      </IconContainer>

      <Divider />

      <LoadingText texts={loadingLabels} fontSize={fontSizeMap[size]} fontWeight="medium"/>
    </Fragment>);
    const errorContent = (<Fragment>
      <IconContainer>
        <FalconWrapper $state="error">
          <Falcon icon="xmark"/>
        </FalconWrapper>
      </IconContainer>

      <Divider />

      <Typography $fontSize={fontSizeMap[size]} $fontWeight="medium">
        {errorLabel}
      </Typography>
    </Fragment>);
    const contentMap = {
        loading: loadingContent,
        error: errorContent,
    };
    return (<Fragment>
      {state !== 'completed' && showContainer && (<Box width="100%" height="100%" alignItems="center" justifyContent="center">
          <Container $size={size} $showAnimation={state === 'loading'}>
            <AnimatePresence mode="wait" initial={false}>
              <motion.div key={state} initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 6 }} transition={{ duration: 0.25, ease: 'easeInOut' }} style={{ display: 'flex', alignItems: 'center', gap: 'inherit' }}>
                {contentMap[state]}
              </motion.div>
            </AnimatePresence>
          </Container>
        </Box>)}

      {showChildren &&
            (childrenFadedIn ? (children) : (<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} style={{
                    position: 'inherit',
                    display: 'inherit',
                    flex: 'inherit',
                    flexDirection: 'inherit',
                    gap: 'inherit',
                    overflow: 'inherit',
                }} onAnimationComplete={() => setChildrenFadedIn(true)}>
            {children}
          </motion.div>))}
    </Fragment>);
}
